export default {
  opponentRank: {
    rankSummary: "Ranking {{rank}} in {{marketName}}",
    feedSubtitle: "Ranking DEF {{team}}",
  },
};
